import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const Hero = () => {
  return (
    <Wrapper>
      <StaticImage
        src="../assets/images/map.jpg"
        className="hero-img"
        layout="fullWidth"
        placeholder="blurred"
        alt="foto de portada"
      />
      <div className="info">
        <div className="hero-center">
          <div className="text-container">
            <h3>CONDUCE HOY MISMO EL AUTO QUE NECESITAS</h3>
            <p>
              Reserva, envíanos tu ubicación y vamos donde te encuentres. 24hrs,
              Puerto Montt - Puerto Varas.
            </p>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export default Hero

const Wrapper = styled.section`
  margin-top: 1rem;
  position: relative;
  height: 60vh;
  .hero-img {
    height: 100%;
  }

  .info {
    position: absolute;
    height: 200px;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    background: rgb(56, 56, 52);
    background: linear-gradient(
      0deg,
      rgba(56, 56, 52, 0.577468487394958) 0%,
      rgba(84, 84, 77, 0.6727065826330532) 45%,
      rgba(64, 60, 53, 0.7483368347338936) 86%
    );
  }

  .text-container {
    color: var(--white);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    h3 {
      margin-top: 0.5rem;
    }
  }

  @media (min-width: 576px) {
    .text-container h3 {
      margin-top: 2rem;
    }
  }
`
